// @flow

/*
 * FIXME: eslint reports duplicate exports because of how we handle hybrid TS/Flow packages currently.
 * Once this package is entirely converted to TS, we can re-enable the import/export rule
 */
/* eslint-disable import/export */

export * from './index.ts';

export * from './authConnection';
export * from './fetch';
export * from './DOMUtils';
export { default as andify } from './andify';
export {
  convertHtmlAstToReactElements,
  isZapTemplateNode,
  isYoutubeNode,
  isWistiaNode,
} from './html';
export type { HTMLAST } from './html';
export {
  camelCaseKeysDeep,
  changeKeysDeepWith,
  snakeCaseKeysDeep,
} from './changeKeysDeep';
export { default as createPopupSplash } from './createPopupSplash';
export { default as createReducer } from './createReducer';
export { default as decodeHTMLEntities } from './decodeHTMLEntities';
export { default as exists } from './exists';
export { default as fuzzyscore } from './fuzzyscore';
export { default as fuzzysearch } from './fuzzysearch';
export { default as get } from './get';
export { default as getGravatarUrl } from './getGravatarUrl';
export { default as getKeys } from './getKeys';
export { default as getTld } from './getTld';
export { default as isEmptyString } from './isEmptyString';
export { default as isCrawler } from './isCrawler';
export { default as loadScript } from './loadScript';
export { default as measure } from './performance/measure';
export { default as timer } from './performance/timer';
export { default as onceAndDebug } from './onceAndDebug';
export { default as orify } from './orify';
export { default as parseSeparatedList } from './parseSeparatedList';
export { default as setHocDisplayName } from './setHocDisplayName';
export { default as singular } from './singular';
export { default as toLowerCaseString } from './toLowerCaseString';
export { default as uid } from './uid';
export { default as urlToYouTubeId } from './urlToYouTubeId';
export { default as withMapProps } from './withMapProps';
export { default as z } from './z';

// TODO(vitorbal): these color utils don't belong in our generic common-utils and should be extracted.
import * as colorUtils from './color';
// TODO(vitorbal): these service utils don't belong in our generic common-utils and should be extracted.
import * as serviceUtils from './services';
export { serviceUtils };

export { colorUtils };

export * from './types';
export * from './flow-types.js';
